import React from 'react';
import './Loader.css';

const Loader = ({ size = 50, color = '#474554', className = '' }) => {
    const style = {
        '--uib-size': `${size}px`,
        '--uib-color': color,
    };

    return (
        <div className={`newtons-cradle ${className}`} style={style}>
            <div className="newtons-cradle__dot" />
            <div className="newtons-cradle__dot" />
            <div className="newtons-cradle__dot" />
            <div className="newtons-cradle__dot" />
        </div>
    );
};

export default Loader;
